
import { Component, Prop, Vue } from 'vue-property-decorator';

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { agreeDisagreeInfoType, schedule2DataInfoType } from '@/types/Application/ReplyFamilyLawMatter/Pdf';
import { replyExistingParentingArrangementsDataInfoType } from '@/types/Application/ReplyFamilyLawMatter/ParentingArrangements';

@Component({
    components:{
        UnderlineForm,
        CheckBox
    }
})

export default class Schedule2 extends Vue {

    @Prop({required:true})
    result!: any;

    @Prop({required:true})
    agreeDisagreeResults!: agreeDisagreeInfoType;

    dataReady = false;
    exParentArrInfo = {} as schedule2DataInfoType; 
   
    mounted(){
        this.dataReady = false;        
        this.extractInfo();       
        this.dataReady = true;
    }

    public extractInfo(){        
        this.exParentArrInfo = this.getExistingParentingArrangementsInfo();
    }

    public getExistingParentingArrangementsInfo(){
        let existingParentingArrangements = {} as schedule2DataInfoType; 

        if(this.result.replyExistingParentingArrangementsSurvey){

            const existingInfo: replyExistingParentingArrangementsDataInfoType = this.result.replyExistingParentingArrangementsSurvey;

            const disagreeItem = (this.agreeDisagreeResults.existingParentResp.opApplied && !this.agreeDisagreeResults.existingParentResp.agree)
                || (this.agreeDisagreeResults.existingParentTime.opApplied && !this.agreeDisagreeResults.existingParentTime.agree)
                || (this.agreeDisagreeResults.existingParentTimeConditions.opApplied && !this.agreeDisagreeResults.existingParentTimeConditions.agree);

                console.log(this.agreeDisagreeResults)

            if (disagreeItem){
                if (existingInfo.existingType == 'finalOrder'){
                    existingParentingArrangements.existingType = 'finalOrder';
                    existingParentingArrangements.agreeNeedsChanges = existingInfo.agreeFinalOrder == 'y';
                    existingParentingArrangements.agreeBestInterest = false;                
                } else if (existingInfo.existingType == 'agreement'){
                    existingParentingArrangements.existingType = 'agreement';
                    existingParentingArrangements.agreeBestInterest = existingInfo.agreeAgreement == 'y';
                    existingParentingArrangements.agreeNeedsChanges = false;
                }                
                existingParentingArrangements.disagreeExpl = existingInfo.disagreeReason?existingInfo.disagreeReason:''
                existingParentingArrangements.noChange = existingInfo.desiredOrderChoice == 'noChange';
                existingParentingArrangements.change = existingInfo.desiredOrderChoice == 'differentChange';
                const changeExplanationRequired = (existingInfo.desiredOrderChoice == 'differentChange') && existingInfo.requestedParentingArrangements
                existingParentingArrangements.changeExpl = changeExplanationRequired?existingInfo.requestedParentingArrangements:'';
                existingParentingArrangements.bestInterestExpl = existingInfo.childBestInterestReason?existingInfo.childBestInterestReason:'';

            } else {
                existingInfo.existingType = '';
                existingParentingArrangements.agreeBestInterest = false;
                existingParentingArrangements.agreeNeedsChanges = false;
                existingParentingArrangements.disagreeExpl = '';
                existingParentingArrangements.noChange = false;
                existingParentingArrangements.change = false;
                existingParentingArrangements.changeExpl = ''
                existingParentingArrangements.bestInterestExpl = '';
            }              
        } 
        
        return existingParentingArrangements;
    }
}
